export default {
  tabs: {
    overview: 1,
    orderStatistic: 2,
    foreign: 3,
    properietary: 4,
  },

  colorChangeAndPercenChange: {
    REF_PRICE: 'referenceValue',
    FLOOR_PRICE: 'floorValue',
    CEILING_PRICE: 'ceilingValue',
  },

  priceDataTableOverview: {
    DATE: 'tradingDate',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'closeValue',
    CHANGE: 'valueChange',
    PERCENT_PRICE_CHANGE: 'percentValueChange',
    OPEN: 'openValue',
    HIGH: 'highestValue',
    LOW: 'lowestValue',
    // OPEN_INDEX: 'openValue',
    // HIGH_INDEX: 'highestValue',
    // LOW_INDEX: 'lowestValue',
    AVERAGE_PRICE: 'averageValue',
    MATCHED_VOLUME: 'totalMatchVolume',
    MATCHED_VALUE: 'totalMatchValue',
    PUT_THROUGH_VOL: 'totalDealVolume',
    PUT_THROUGH_VALUE: 'totalDealValue',
    TOTAL_VOL: 'totalVolume',
    TOTAL_VALUE: 'totalValue',
  },

  priceDataTableOrderStatistic: {
    DATE: 'tradingDate',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'closeValue',
    CHANGE: 'valueChange',
    PERCENT_PRICE_CHANGE: 'percentValueChange',
    NR_OF_BUY_ORDER: 'totalBuyTrade',
    BUY_VOL: 'totalBuyTradeVolume',
    VOLUMN_BUY_ORDER: 'buyOrderAvgVol',
    NR_OF_SELL_ORDER: 'totalSellTrade',
    SELL_VOL: 'totalSellTradeVolume',
    VOLUMN_SELL_ORDER: 'sellOrderAvgVol',
    NET_VOL: 'netVolOrderStatistic',
  },

  priceDataTableForeign: {
    DATE: 'tradingDate',
    //LAST : 'ClosePriceAdjusted' ,
    LAST: 'closeValue',
    CHANGE: 'valueChange',
    PERCENT_PRICE_CHANGE: 'percentValueChange',
    BUY_ORDER_VOL: 'foreignBuyVolume',
    BUY_ORDER_VALUE: 'foreignBuyValue',
    SELL_ORDER_VOL: 'foreignSellVolume',
    SELL_ORDER_VALUE: 'foreignSellValue',
    NET_VOLUME: 'netVol',
    NET_VALUE: 'netValue',
    FOREIGN_ROOM: 'foreignCurrentRoom',
    OWNED_RATIO: 'foreignerPercentage',
  },

  priceDataTableForeignIgnore: {
    SHARE_ISSUE: 'shareIssue',
    FOREIGN_CURRENT_ROOM: 'foreignCurrentRoom',
    FOREIGN_TOTAL_ROOM: 'foreignTotalRoom',
  },

  priceDataTableProprietary: {
    DATE: 'tradingDate',
    LAST: 'closeValue',
    CHANGE: 'valueChange',
    PERCENT_PRICE_CHANGE: 'percentValueChange',
    BUY_VOL: 'proprietaryTotalBuyTradeVolume', //
    BUY_VALUE: 'proprietaryTotalBuyTradeValue', //
    SELL_VOL: 'proprietaryTotalSellTradeVolume', //
    SELL_VALUE: 'proprietaryTotalSellTradeValue', //
    NET_VOL: 'netVolProprietary',
    NET_VALUE: 'netValueProprietary',
  },

  listTimeRange: ['Daily', 'Weekly', 'Monthly', 'Yearly'],

  listTimeRangeByKey: {
    Daily: { key: 'Daily', name: 'DAILY' },
    Weekly: { key: 'Weekly', name: 'WEEKLY' },
    Monthly: { key: 'Monthly', name: 'MONTHLY' },
    Yearly: { key: 'Yearly', name: 'YEARLY' },
  },

  defaultTimeRange: 'Daily',

  listTicker: {
    ORGAN_CODE: 'organCode',
    TICKER: 'ticker',
    ORGAN_SHORT_NAME: 'organShortName',
    COM_GROUP_CODE: 'comGroupCode',
  },

  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    COM_GROUP_NAME: 'comGroupName',
    PARENT_COM_GROUP_CODE: 'parentComGroupCode',
  },

  listIndexName: {
    vnIndex: 'VNINDEX',
    hnIndex: 'HNXIndex',
    upcomIndex: 'UpcomIndex',
  },

  listIndexExchange: {
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },

  intervalGetData: 1000 * 60 * 10,
};
